import React, { useContext } from 'react';

import styled from '@emotion/styled';

import PrimaryButton from '../../../components/Button/PrimaryButton';
import { ModalContext } from '../../../context/ModalContext';

const CreateRack = () => {
  const modalContext = useContext(ModalContext);

  const createRackHandler = (e: any) => {
    modalContext?.displayModal(true);
  };

  return (
    <Container>
      <Label>Rack List</Label>
      <PrimaryButton className="fitContent" onClick={createRackHandler}>
        Create Rack
      </PrimaryButton>
    </Container>
  );
};

export default CreateRack;

const Container = styled.div`
  display: flex;
  /* border: 2px solid red; */
  justify-content: space-between;
  align-items: center;
`;

const Label = styled.h1`
  color: #2c2421;
  font-size: 1.25rem;
  font-weight: 700;
`;
